import React, { useState, useEffect } from "react"

import createPersistedState from "use-persisted-state"

import Tabs from "./Tabs"

const SETTINGS_KEY = "com.box.developer.programming-language"
const useLangState = createPersistedState(SETTINGS_KEY)

/**
 * A wrapper around all the tabs. Keeps track of overall
 * state and tracks preference in local storage
 */
const Component = ({ children }) => {
  // keep track of the registered labels
  const [state, setState] = useState({
    labels: [],
    selected: null,
    jsEnabled: false,
  })

  // use local storage to load the user preference
  const [preference, setPreference] = useLangState("cURL")

  const setSelected = (selected) => setState((state) => ({ ...state, ...{ selected } }))

  // // on load/update, check if the preference matches
  // // a registered label for this set of tabs
  useEffect(() => {
    // if so, set the preference to be selected
    if (state.labels.includes(preference)) {
      setSelected(preference)
      // if not, set the first tab to be selected
    } else {
      setSelected(state.labels[0])
    }
    // make sure to re-evaluate this every time ids
    // or the preference changes
  }, [preference, state.labels])

  useEffect(
    () => setState((state) => ({ ...state, ...{ jsEnabled: true } })),
    [],
  )

  // When a label is registered, add it to the list
  const registerLabel = (id) => {
    setState((state) => ({ ...state, ...{ labels: [...state.labels, id] } }))
  }

  // When a label is selected, update the locally stored preference
  const onSelection = (label) => {
    setPreference(label)
  }

  // We expose all these elements to the tabs through
  // a context
  return (
    <Tabs
      registerLabel={(id) => registerLabel(id)}
      state={state}
      onSelection={onSelection}
    >
      {children}
    </Tabs>
  )
}

export default Component
